export class ProfileSalaryRequest {
	bAguinaldo: boolean = false;
	bBono: boolean = false;
	bVacaciones: boolean = false;
	baguinaldo: boolean;
	bbono: boolean;
	bonusAmount: number;
	bvacaciones: boolean;
	company: number;
	id: number;
	name: string;
	pAguinaldo: boolean = false;
	pBono: boolean = false;
	pVacaciones: boolean = false;
	paguinaldo: boolean;
	payment: number = 4;
	pbono: boolean;
	proAmount: any;
	pvacaciones: boolean;
	rAguinaldo: boolean = false;
	rBono: boolean = false;
	rVacaciones: boolean = false;
	raguinaldo: boolean;
	rbono: boolean;
	rIggs: boolean = false;
	relationAmount: number;
	rvacaciones: boolean;
	shift: number = 0;
	type: number = 0;
}